/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-12 14:20:50
 *
 *******************************************************/
//@flow
import React from 'react';
import classnames from 'classnames';
import { PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE } from 'src/constants/theme-settings';

export const RenderRadioPriceDisplay = (field: Object) => {
  const isDisabled = Boolean(field.disabled);
  const invisible = Boolean(field.invisible);
  const radioButtonClass = classnames('radio-button-2', {
    disabled: isDisabled
  });
  const labelClass = classnames('Polaris-Button', {
    checked: field.input.value === field.id
  });

  const renderDisplay = () => {
    const value = field.id;
    if (value === PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.RIGHT) {
      return (
        <span className="Polaris-Button__Text">
          $$$ <s>$$$</s>
        </span>
      );
    }
    if (value === PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.LEFT) {
      return (
        <span className="Polaris-Button__Text">
          <s>$$$</s> $$$
        </span>
      );
    }
    if (value === PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.TOP) {
      return (
        <div className="Polaris-Button__Text">
          <p style={{ textAlign: 'left' }}>
            <s>$$$</s>
          </p>
          <p>$$$</p>
        </div>
      );
    }
    if (value === PRODUCT_COMPARE_AT_PRICE_POSITION_VALUE.BOTTOM) {
      return (
        <div className="Polaris-Button__Text">
          <p>$$$</p>
          <p style={{ textAlign: 'left' }}>
            <s>$$$</s>
          </p>
        </div>
      );
    }
  };

  return (
    <div className={radioButtonClass}>
      <label htmlFor={`${field.input.name}_${field.id}`} className={labelClass}>
        <span
          className="Polaris-Button__Content"
          style={{ visibility: isDisabled && invisible ? 'hidden' : 'visible' }}>
          {renderDisplay()}
        </span>
        <input
          type="radio"
          id={`${field.input.name}_${field.id}`}
          name={field.input.name}
          value={field.id}
          checked={field.input.value === field.id}
          onChange={(e: any) => {
            field.input.onChange(e.target.value);
          }}
          disabled={isDisabled}
        />
      </label>
    </div>
  );
};
